import { CircularProgress, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import SaveAlt from '@material-ui/icons/SaveAlt';
import React from 'react';

import AnexoApi from '../../api/AnexoApi';

const styles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
});

class ButtonDownloadAnexo extends React.Component {
  anexoApi = new AnexoApi();

  state = {
    isLoading: false,
  };

  handleDownload = async (id, filename) => {
    this.setState({isLoading: true});
    await this.anexoApi.download(id, filename);
    this.setState({isLoading: false});
  }

  render () {
    const { classes, anexo } = this.props;
    return (
      <div>
        {this.state.isLoading
          ? <CircularProgress />
          : <IconButton
            button
            className={classes.button}
            aria-label='Baixar anexo'
            onClick={() => this.handleDownload(anexo.txtObjetoGed, anexo.nomArquivo)}
          >
            <SaveAlt />
          </IconButton>
        }
      </div>
    );
  }
}

export default withStyles(styles)(ButtonDownloadAnexo);
